import { makeAutoObservable, runInAction } from 'mobx'
import { restClient } from '@/Core'

/**
 * Local store of `RequestHistoryTab`.
 * Owns the loaded history array and a request-in-flight flag.
 * Instantiated per tab mount via `useState(() => new RequestHistoryTabStore())`.
 */
export class RequestHistoryTabStore {
    history: any[] = []
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    async load(uuid: string | undefined): Promise<void> {
        if (!uuid) return
        this.loading = true
        try {
            const data: any = await restClient.get(`/services/transport-requests/${uuid}/history`)
            const items = data?.items || data?.['hydra:member'] || data || []
            runInAction(() => {
                this.history = Array.isArray(items) ? items : []
            })
        } catch {
            runInAction(() => {
                this.history = []
            })
        } finally {
            runInAction(() => {
                this.loading = false
            })
        }
    }
}
